export default "__VITE_PUBLIC_ASSET__6b12f710__"